import { useState } from "react";
import { useNavigate, Link, useLocation } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { formatApiErrorDetail } from "@/lib/api";

const Login = () => {
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const u = await login(email, password);
      toast.success("Welcome back.");
      navigate(u.role === "admin" ? "/admin" : location.state?.from || "/shop");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    }
    setLoading(false);
  };

  return (
    <div className="max-w-md mx-auto px-6 pt-24 pb-28">
      <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-[#8C3A3A] mb-5">Account</p>
      <h1 className="font-serif font-light text-5xl md:text-6xl tracking-tight text-[#1A1A1A] mb-10">Sign In</h1>
      <form onSubmit={submit} className="space-y-6" data-testid="login-form">
        <label className="block">
          <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-[#595959]">Email</span>
          <input data-testid="login-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="mt-2 w-full bg-transparent border border-[#E5E1D8] rounded-none px-4 py-3 font-sans text-sm focus:border-[#1A1A1A] outline-none transition-colors" />
        </label>
        <label className="block">
          <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-[#595959]">Password</span>
          <input data-testid="login-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="mt-2 w-full bg-transparent border border-[#E5E1D8] rounded-none px-4 py-3 font-sans text-sm focus:border-[#1A1A1A] outline-none transition-colors" />
        </label>
        {error && <p data-testid="login-error" className="font-mono text-[11px] text-[#8C3A3A]">{error}</p>}
        <button type="submit" disabled={loading} data-testid="login-submit" className="w-full bg-[#1A1A1A] text-[#F9F8F6] py-4 font-mono text-[11px] uppercase tracking-[0.25em] hover:bg-[#8C3A3A] transition-colors disabled:opacity-50">
          {loading ? "Signing in…" : "Sign In"}
        </button>
      </form>
      <p className="mt-8 font-sans text-sm text-[#595959]">
        New here? <Link to="/register" className="text-[#8C3A3A] hover:underline">Create an account</Link>
      </p>
    </div>
  );
};

export default Login;
